var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cash",
    transform: "translate(0.249 0.249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148504",
    "data-name": "Rectangle 148504",
    width: 32,
    height: 32,
    transform: "translate(-0.249 -0.249)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "money",
    transform: "translate(2.723 5.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10855",
    "data-name": "Group 10855",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7377",
    "data-name": "Path 7377",
    d: "M26.021,50.907a.514.514,0,0,0-.251-.217L23.9,49.924l1.938-1.141a.514.514,0,0,0-.067-.92L23.9,47.1l1.938-1.141a.521.521,0,0,0-.072-.925L18.4,42.012,14.769,40.47a.514.514,0,0,0-.185-.036L8.672,38.028a.514.514,0,0,0-.447.026L.3,42.506a.514.514,0,0,0,.051.941l1.912.792L.3,45.333a.514.514,0,0,0,.051.92l1.912.792L.313,48.14a.514.514,0,0,0,.041.961l1.912.787L.313,50.983a.514.514,0,0,0,.051.92l6.647,2.822a.51.51,0,0,0,.077.046l3.635,1.542,6.683,2.843a.514.514,0,0,0,.463-.031l7.968-4.688a.514.514,0,0,0-.067-.92L23.9,52.751l1.938-1.141A.514.514,0,0,0,26.021,50.907Zm-1.6-2.494-6.853,4.036-6.128-2.6V48.135L17.4,50.669a.512.512,0,0,0,.463-.031l4.92-2.894Zm.021-2.833-6.873,4.036L12,47.251l6.272-4.19ZM6.76,53.512,1.717,51.369,3.449,50.4l3.316,1.409Zm0-2.827L1.717,48.541l1.732-.982,3.316,1.409Zm0-2.827L1.717,45.719l1.732-.972,3.316,1.409ZM1.717,42.891l6.8-3.82,4.93,2.02-6.21,4.144Zm8.919,4.041a.514.514,0,0,0-.226.427V55.07L7.793,53.96V46.1L14.6,41.56l2.534,1.028Zm13.783,7.135L17.566,58.1l-6.128-2.6V53.79L17.4,56.3a.514.514,0,0,0,.463-.031l4.92-2.894Zm-6.853,1.2-6.128-2.6V50.962L17.406,53.5a.514.514,0,0,0,.463-.031l4.92-2.894,1.63.668Z",
    transform: "translate(0 -37.989)",
    fill: "#004fe0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.0dbca52f37c3d75541c4a2fd31c6c1d2.svg";
export { ForwardRef as ReactComponent };